import { render, staticRenderFns } from "./UdeskMedicalPreference.vue?vue&type=template&id=3a6c74a1&scoped=true"
import script from "./UdeskMedicalPreference.vue?vue&type=script&lang=js"
export * from "./UdeskMedicalPreference.vue?vue&type=script&lang=js"
import style0 from "./UdeskMedicalPreference.vue?vue&type=style&index=0&id=3a6c74a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c74a1",
  null
  
)

export default component.exports